const AccessAuthorization = "/access-authorization";
const Competitor = "/competitor";
const Station = "/station";
const PriceBuildUp = "/price-build-up";
const PriceMovement = "/price-movement";
const Path = {
  Slash: "/",
  Auth: "/auth",
  AccessAuthorization: AccessAuthorization,
  UserAccess: `${AccessAuthorization}/user-access`,
  Competitor: Competitor,
  CompetitorList: `${Competitor}/list`,
  AddCompetitor: `${Competitor}/add`,
  EditCompetitor: `${Competitor}/edit`,
  ViewCompetitor: `${Competitor}/view`,
  Station: Station,
  StationList: `${Station}/list`,
  AddStation: `${Station}/add`,
  EditStation: `${Station}/edit`,
  ViewStation: `${Station}/view`,
  PriceBuildUp: PriceBuildUp,
  PriceBuildUpList: `${PriceBuildUp}/list`,
  AddPriceBuildUp: `${PriceBuildUp}/add`,
  EditPriceBuildUp: `${PriceBuildUp}/edit`,
  ViewPriceBuildUp: `${PriceBuildUp}/view`,
  PriceMovement: PriceMovement,
  PriceMovementList: `${PriceMovement}/list`,
  AddPriceMovement: `${PriceMovement}/add`,
  EditPriceMovement: `${PriceMovement}/edit`,
  Downloads: "/downloads",
};

export default Path;
